import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import { Box, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import Select from '@material-ui/core/Select';
import { getCookie } from "../../services/Cookies";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import Checkbox from "@material-ui/core/Checkbox";
import StopSharpIcon from "@material-ui/icons/StopSharp";
import { BreadcrumbPage } from "../../shared";
// import Filter from "./Filter";
import TrendsList from "./TrendsList";
import { getRequest, postRequest } from "../../services/ApiServices";
import filterObj from "./FilterInstantiation";
import SingleChart from "../../shared/charts/SingleChart";
//import { getCurrentDate, getCurrentDateOfBelow } from "../../services/DateServices";
import { getCurrentDate, getCurrentDateOfBelow, getDefaultFuelDate, getDefaultLubeDate, getDefaultTrendsDate, getDefaultTotDate } from "../../services/DateServices";
import FilterComponents from "../FilterComponents/FilterComponents";
import moment from 'moment';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Chart  from "./Chart";
import { chartObj } from "./ChartConstants";
import AllChart from "./AllChart";
import Helppage from "./Helppage";

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    color: theme.palette.text.secondary,
  },
  gridSpacing: {
    margin: "0 !important",
    width: "100% !important",
  },
  btnFilters: {
    color: "#ff4717",
    border: "1px solid rgb(255 71 23)",
  },
  heading: {
    color: "#ff4717",
  },
  mb: {
    marginTop: "15px",
  },
  root: {
    display: "flex",
    padding: "0px",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: "65px",
    height: "100vh",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "white",
  },
  theadingstyles: {
    background: "rgb(26 26 49)",
    padding: "12px",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    color: "white",
    fontSize: "16px",
  },

  activeListColor: {
    color: "#ff4717 !important",
  },
  shiplist: {
    "&.Mui-selected .MuiListItemText-root span": {
      color: "#ff4717 !important",
    },
  },
  displayFlex: {
    display: "flex !important",
  },
  selectWidth: {
    width: "100% !important"
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: "100%",
    "& select": {
      padding: "6px"
    }
  },
  container1:{
    "&.MuiGrid-grid-md-6":{
    marginLeft:"100px"
    }
  }
}));

function TrendsShipsOCM(props) {
  const BreadcrumbList = [{ name: "Trends", url: "" }];
  const [shipList, setShipList] = useState([]);
  const [transformerId, setTransformerId] = useState([]);
  const [transformerListequip, setTransformerListequip] = useState([]);
  const [formObj, setFormObj] = React.useState(filterObj);
  const [randomNumber, setRandomNumber] = useState(0);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [selectedEquimentKey, setSelectedEquimentKey] = useState([]);
  const [isFilterDisabled,setFilterDisabled] = useState(false)
 

  const getFilterShipListData = (formObj) => {

    let filterObj = {};
    let Data = {};
    if (formObj !== "" && formObj !== undefined) {
      if (formObj.HistoricVessel == true) {
        filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
      } else {
        filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
      }
      if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
      if (formObj.shipNameImokey && formObj.shipNameImokey.length > 0) { filterObj = { ...filterObj, shipNameImokey: formObj.shipNameImokey } }
      //if (formObj.Fqtbunkerport && formObj.Fqtbunkerport.length > 0) { filterObj = { ...filterObj, Fqtbunkerport: formObj.Fqtbunkerport } }
      if (formObj.lubeequipname && formObj.lubeequipname.length > 0) { filterObj = { ...filterObj, lubeequipname: formObj.lubeequipname } }
      if (formObj.lubeequipmake && formObj.lubeequipmake.length > 0) { filterObj = { ...filterObj, lubeequipmake: formObj.lubeequipmake } }
      if (formObj.lubeequipmodel && formObj.lubeequipmodel.length > 0) { filterObj = { ...filterObj, lubeequipmodel: formObj.lubeequipmodel } }
      if (formObj.lubelab && formObj.lubelab.length > 0) { filterObj = { ...filterObj, lubelab: formObj.lubelab } }
      if (formObj.lubeShipType && formObj.lubeShipType.length > 0) { filterObj = { ...filterObj, lubeShipType: formObj.lubeShipType } }
      if (formObj.lobrand && formObj.lobrand.length > 0) { filterObj = { ...filterObj, lobrand: formObj.lobrand } }
      if (formObj.lograde && formObj.lograde.length > 0) { filterObj = { ...filterObj, lograde: formObj.lograde } }
      if (formObj.servicetype && formObj.servicetype.length > 0) { filterObj = { ...filterObj, servicetype: formObj.servicetype } }
      if (formObj.ReportedDate) { filterObj = { ...filterObj, ReportedDate: formObj.ReportedDate } }


      if (formObj.ReportedDate) {
        const myJSONData = JSON.stringify(filterObj);
        Data = {
          Data: myJSONData,
        }
      } else {
        let JSONFormat = filterObj;
        JSONFormat = { ...filterObj }
        if (formObj?.lubereportstartdate != null && formObj?.lubereportenddate != null) {
          let ReportStartDate = (formObj?.lubereportstartdate[0]?.startDate ? formObj?.lubereportstartdate[0]?.startDate : formObj?.lubereportstartdate[0]);
          let ReportEndDate = (formObj?.lubereportenddate[0]?.endDate ? formObj?.lubereportenddate[0]?.endDate : formObj?.lubereportenddate[0])
          if (ReportStartDate && ReportEndDate && ReportStartDate != null && ReportEndDate != null) {
            JSONFormat.ReportedDate = {
              startDate: moment(ReportStartDate).format('YYYY/MM/DD'),
              endDate: moment(ReportEndDate).format('YYYY/MM/DD')

            }
          }
        }
        const myJSONData = JSON.stringify(JSONFormat);
        Data = {
          Data: myJSONData,
        }
      }
    }

    dispatch({ type: LOADING, payload: true });

    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Trend/ShipsList/Filter/Lube`;
    //console.log(url);
    postRequest(url, Data)
      .then((res) => {

        //console.log(res);
        if (res.data.length) {
          let totalListArray = [];
          let array =[]
          let existingOfShipsArray = [];
          res.data.map((row) => {
            let listIndex = existingOfShipsArray.
              indexOf(row.currentVesselName);
            if (listIndex > -1) {
              let subObj = {
                equimentName: row.machineryUsage,
                equimentId: row.machineryKey
              }
              // equimentList.push(subObj);
              totalListArray[listIndex].equimentList.push(subObj);
            } else {
              existingOfShipsArray.push(row.currentVesselName);
              const objEq = {
                equimentName: row.machineryUsage,
                equimentId: row.machineryKey
              }
              const obj = {
                shipName: row.currentVesselName, shipId: row.vesselKey,
                equimentList: [objEq]
              }
              totalListArray.push(obj);
            }
         
          });
          setShipList(totalListArray);
         
          // //console.log(totalListArray);
        } else {
          setShipList([]);
          // ToastError(res.data.message);
        }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  const applyFilter = (formObj) => {
    getFilterShipListData(formObj);
    setTransformerListequip([])
  }
  
  const setTransformerSelectedId = (data, row, shipId, Field, ischecked) => {
    debugger
    console.log("data, row, shipId", data, row, shipId);
    if (row.length) {
      setTransformerId(data);
     // setShipId(shipId)
      setTransformerListequip([...row])
    }
    else {
       setTransformerListequip([]);
    }
  }

  const onClear = () => {
    setShipList([]);
    setFormObj(filterObj)
    setSelectedEquimentKey([]);
    setTransformerListequip([])
    
  }


  const removeTransformerList = (item) => {
    //debugger;
    const filtered = transformerListequip?.filter((t) => t.equimentId !== item.equimentId);
    let indexofList=selectedEquimentKey.indexOf(item.equimentId);
    selectedEquimentKey.splice(indexofList,1)
    setTransformerListequip([...filtered]);
    setSelectedEquimentKey(selectedEquimentKey);
  }

 
  
  return (
    <Box component="div" px={2} className={classes.root}>
      <Grid container spacing={3} className={classes.gridSpacing}>
        <Helppage/>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
          <FilterComponents screen = {"trends"} defaultDate ={getDefaultTrendsDate()} filtervalue={["CustomerName", "ShipName_imo", "Service_type", "EquipName", "EquipMake", "EquipModel", "Lab_Lube", "LoBrand", "LubeReportDateComponent", "LoGrade", "LubeShipType"]}  applyFilter={applyFilter} isFilterDisabled={isFilterDisabled} reset={onClear} />
          <Grid className="ast-grid" item xs={12} sm={12} md={4} lg={3}>
        <Box component="h2" m={0} className="blcopy" fontWeight="500"
          style={{ marginRight: "-1em" }}>
          Selected Assets:
        </Box>
      </Grid>
      <div width="100%">
      <Box sx={{  display: 'flex',flexDirection: 'row',flexWrap:'wrap',}}>
      {transformerListequip.length ? transformerListequip.map((item)=>{
       
       return(
        <Stack direction="row" spacing={3}>
      <Chip
      label={`${item.equimentName} (${item.shipName})`} 
     // onDelete={()=>{removeTransformerListequip(item)}}
     onDelete={()=>{removeTransformerList(item)}}
      sx={{margin:"3px",fontSize:"12px"}}
    />
    </Stack>
   
       )
  
       }):null} 
      </Box>
      </div>
          </Paper>
         
        </Grid>
        <Grid item xs={3} md={2}>
          <TrendsList transformerListequip={transformerListequip} shipList={shipList} setTransformerSelectedId={setTransformerSelectedId}
            selectedEquimentKey={selectedEquimentKey} setSelectedEquimentKey={setSelectedEquimentKey}/>
        </Grid>
        <Grid item xs={9} md={10} >
          <Grid container spacing={3} >
          {chartObj.map(( item ) => {
                            return(
                                <Chart chartParameters={item} transformerListequip={transformerListequip} transformerId={transformerId} formObj={formObj} />
                            )                       
                        })} 
                        <AllChart transformerListequip={transformerListequip} transformerId={transformerId} formObj={formObj}/>
                        
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default TrendsShipsOCM;